module.exports = __webpack_public_path__ + "img/tubiao-46.69b7bf6f.png";